const statisticsDe = {
    "user_statistics": "Nutzerstatistiken",
    "menu_item_clicks": "Klicks auf Menüpunkte",
    "statistics": "Statistiken",
    "user_traffic": "Nutzerverkehr",
    "last_7_days": "Letzte 7 Tage",
    "last_30_days": "Letzte 30 Tage",
    "menu_item": "Menüpunkt",
    "click_count": "Klickzahl",
    "error_fetching_user_statistics": "Fehler beim Abrufen der Benutzerstatistik.",
    "error_fetching_menu_item_statistics": "Fehler beim Abrufen der Menüpunktstatistiken.",
    "statistics_feature_not_available": "Die Statistikfunktion ist nur im PRO-Tarif verfügbar. Bitte upgraden Sie Ihr Abonnement, um diese Funktion nutzen zu können.",
    "change_subscription_plan": "Abonnementplan ändern",
    "permission_denied": "Zugriff verweigert",
    "error_fetching_rating_statistics": "Fehler beim Abrufen der Bewertungsstatistik.",
    "menu_item_ratings": "Bewertungen der Menüpunkte",
    "likes": "Gefällt mir",
    "dislikes": "Abneigungen",
    "rating_trends_last_7_days": "Bewertungstrends (letzte 7 Tage)",
    "rating_trends_last_30_days": "Bewertungstrends (letzte 30 Tage)"
};

export default statisticsDe;
